import { Stack } from '@mui/material';

import Information from './Information';
import PollIdentifier from './PollIdentifier';

export interface RightPartProps {
  isPollPublished: boolean;
  isPresenting: boolean;
}

const RightPart = ({ isPollPublished, isPresenting }: RightPartProps) => {
  return (
    <Stack direction="row" alignItems="center" gap={2}>
      <PollIdentifier />
      {(isPollPublished || isPresenting) && <Information />}
    </Stack>
  );
};

export default RightPart;
